import React from "react"
import GeneralLayout from "../layouts/GeneralLayout"
import "../styles.css"

const Contact = () => {
  return (
    <GeneralLayout>
      <div className="contactWrap">
        <div className="container contact-form">
          <div className="contact-image">
            <img
              src="https://image.ibb.co/kUagtU/rocket_contact.png"
              alt="rocket_contact"
            />
          </div>
          <form name="Contact Form" method="POST" data-netlify="true">
            <input type="hidden" name="form-name" value="Contact Form" />
            <h3>Drop Us a Message</h3>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    name="Name"
                    className="form-control"
                    required
                    placeholder="Your Name *"
                  />
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    name="Email"
                    required
                    className="form-control"
                    placeholder="Your Email *"
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    name="Subject"
                    className="form-control"
                    placeholder="Subject"
                    required
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <textarea
                    name="txtMsg"
                    className="form-control"
                    placeholder="Your Message *"
                    style={{ width: "100%", height: "8em" }}
                  ></textarea>
                </div>{" "}
                <div className="form-group">
                  <input
                    type="submit"
                    name="btnSubmit"
                    className="btnContact"
                    value="Send Message"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </GeneralLayout>
  )
}

export default Contact
